// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.title h3{font-weight:400;margin-bottom:20px}.system-vars-contacts-form ::ng-deep .mat-form-field,.system-vars-contacts-form ::ng-deep .mat-mdc-form-field{min-width:210px}`, "",{"version":3,"sources":["webpack://./packages/theme/styles/_settings.scss","webpack://./packages/builder-setup/system-vars/components/system-vars-contacts-tab/system-vars-contacts-tab.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CCQA,UACE,eAAA,CACA,kBAAA,CAIA,8GAEE,eAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@forward \"settings/colors\";\n@forward \"settings/variables\";","/*\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n.title h3 {\n  font-weight: 400;\n  margin-bottom: 20px;\n}\n\n.system-vars-contacts-form {\n  ::ng-deep .mat-form-field,\n  ::ng-deep .mat-mdc-form-field {\n    min-width: 210px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
